import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Zap } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-cream pt-5 pb-6 px-4 relative" data-id="element-103">
      <div className="max-w-5xl mx-auto text-center" data-id="element-104">
        <h1 className="font-display text-xl md:text-3xl lg:text-4xl font-bold text-brand-navy leading-[1.1] uppercase mb-3 max-w-3xl mx-auto" data-id="element-105">
          Dejá de buscar. Todo lo que necesitás para enseñar{' '}
          <span className="green-highlight" data-id="element-106">Producción Acuícola</span> está acá,
          en un solo sistema.
        </h1>

        <p className="text-sm md:text-base text-brand-mute font-medium max-w-2xl mx-auto leading-snug mb-4" data-id="element-107">
          <span className="font-bold text-brand-ink" data-id="element-108">
            6 tomos técnicos, planificación anual lista, actividades de campo,
            evaluaciones con rúbrica y proyectos integradores.
          </span>{' '}
          Todo listo para usar el lunes.
        </p>

        <div onClick={scrollToCompra} className="cursor-pointer max-w-2xl mx-auto mb-4 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/iQdFk8JXgfi2mWBqf8a8ma/WhatsApp_Image_2026-05-09_at_20.13.14.jpg" alt="Sistema Acuicultura Pro — 6 tomos + materiales" className="w-full h-auto" data-id="element-110" />
        </div>

        <div className="max-w-md mx-auto mb-3" data-id="element-111">
          <Button data-id="element-112">🚀 Quiero el Sistema Acuicultura Pro</Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[11px] md:text-sm text-brand-navy font-bold uppercase tracking-wide" data-id="element-113">
          <div className="flex items-center" data-id="element-114">
            <Zap className="w-4 h-4 mr-1 text-brand-green" data-id="element-115" /> Acceso inmediato
          </div>
          <div className="flex items-center" data-id="element-116">
            <ShieldCheck className="w-4 h-4 mr-1 text-brand-green" data-id="element-117" /> Garantía 7
            días
          </div>
          <div className="flex items-center" data-id="element-118">
            <span className="text-brand-green mr-1 font-black" data-id="element-119">$</span> Pagá con
            Mercado Pago
          </div>
        </div>
      </div>
    </section>;
}